function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.02 2.88C16.54 2.4 15.58 2 14.9 2H9.1c-.68 0-1.64.4-2.12.88l-4.1 4.1C2.4 7.46 2 8.42 2 9.1v5.8c0 .68.4 1.64.88 2.12l1.53 1.53L18.55 4.41l-1.53-1.53zm4.1 4.1l-1.51-1.51L5.47 19.61l1.51 1.51c.48.48 1.44.88 2.12.88h5.8c.68 0 1.64-.4 2.12-.88l4.1-4.1c.48-.48.88-1.44.88-2.12V9.1c0-.68-.4-1.64-.88-2.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.49 20.47c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l1.92-1.92-1.06-1.06-1.92 1.92zM21.53 3.55c.29-.29.29-.77 0-1.06a.755.755 0 00-1.06 0l-1.92 1.92 1.06 1.06 1.92-1.92z"
})));